export interface Options {
    attribute: string;
    name: string
    filter?: string | false,
    filterable?: boolean;
    sortable?: boolean;
    orderable?: boolean;

    [key: string]: any,
}

export abstract class Column {

    /**
     * The attribute of the data.
     */
    public attribute: string;

    public name: string;

    /**
     * The column type.
     */
    public type: string;

    /**
     * The column width in pixels;
     */
    public width = 150;

    public sortable = true;

    public filterable = true;

    /**
     * The column filter name.
     */
    public filter: string | false = false;

    public reorderable = true;

    [key: string]: any;

    /**
     * @param options - The column options.
     */
    constructor(
        options?: Options,
    ) {
        //
    }

    /**
     * Set the object properties.
     *
     * This method has to be called on every child.
     * Due to Javascript the parameters given in the constructor are overwritten
     * by the object children's default parameters when not called.
     *
     * @param options
     * @private
     */
    protected __construct(options: Options): void {
        Object.assign(this, options);
    }

}


// WEBPACK FOOTER //
// ./libs/chassis-datatable/src/classes/column.ts